export default __webpack_public_path__ + "static/arrow-green-up-1e1cf97a60a170cb0bb672693130a6e6.png";